module.exports = __webpack_public_path__ + "static/media/Screen_Shot_4.ce272f6e.png";